import { CheckCircle } from 'lucide-react';
// import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import type { SimulationResponse } from './types';

export interface SimulationResultsProps {
  result: SimulationResponse;
  onDownload?: (path: string) => void;
}

export function SimulationResults({
  result,
//   onDownload,
}: SimulationResultsProps) {
//   const handleDownload = (gcsUrl: string) => {
//     if (onDownload) {
//       onDownload(gcsUrl);
//     } else {
//       navigator.clipboard.writeText(gcsUrl);
//       console.log('GCS URL copied to clipboard:', gcsUrl);
//     }
//   };

  return (
    <div className="space-y-3">
      {/* Success Header */}
      <div className="flex items-center gap-2 text-sm font-medium text-green-600">
        <CheckCircle className="h-4 w-4" />
        Simulation Complete
        <Badge variant="secondary" className="ml-auto text-xs">
          {result.runtime_seconds.toFixed(1)}s
        </Badge>
      </div>
      
      {/* Job Info */}
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        <span>Job ID: {result.job_id}</span>
        <Badge variant="outline" className="text-xs">
          {result.status}
        </Badge>
      </div>

      {/* Results Grid */}
      <Card>
        <CardHeader className="pb-2">
          <CardTitle className="text-xs font-medium text-muted-foreground">Results</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-2 gap-2 text-xs">
          <div>
            <span className="text-muted-foreground">Max Depth:</span>
            <div className="font-semibold">
              {(result.results.max_depth_m * 100).toFixed(1)} cm
            </div>
          </div>
          <div>
            <span className="text-muted-foreground">Volume:</span>
            <div className="font-semibold">
              {result.results.volume_m3.toFixed(1)} m³
            </div>
          </div>
          <div>
            <span className="text-muted-foreground">Wet Cells:</span>
            <div className="font-semibold">
              {result.results.cells_with_water.toLocaleString()}
            </div>
          </div>
          <div>
            <span className="text-muted-foreground">Ponds:</span>
            <div className="font-semibold">{result.results.significant_ponds}</div>
          </div>
        </CardContent>
      </Card>

      {/* Download Buttons */}
      {/* <div className="space-y-1 text-xs text-muted-foreground mb-1">
        Result Files (click to copy GCS URL)
      </div>
      <div className="space-y-1">
        <Button
          variant="outline"
          size="sm"
          className="w-full justify-start text-xs h-8"
          onClick={() => handleDownload(result.files.peak_depth_tif)}
        >
          <Download className="h-3 w-3 mr-2" />
          Peak Depth
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="w-full justify-start text-xs h-8"
          onClick={() => handleDownload(result.files.filtered_ponds_tif)}
        >
          <Download className="h-3 w-3 mr-2" />
          Filtered Ponds
        </Button>
        <Button
          variant="outline"
          size="sm"
          className="w-full justify-start text-xs h-8"
          onClick={() => handleDownload(result.files.metadata_json)}
        >
          <Download className="h-3 w-3 mr-2" />
          Metadata
        </Button>
      </div> */}

      {/* Top Ponds */}
      {result.ponds && result.ponds.length > 0 && (
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-xs font-medium text-muted-foreground">
              Top Ponds
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-1">
            {result.ponds.slice(0, 5).map((pond, i) => (
              <div
                key={pond.id}
                className="flex items-center justify-between text-xs py-1 border-b last:border-0"
              >
                <span className="text-muted-foreground">#{i + 1}</span>
                <span className="font-medium">{pond.area_m2.toFixed(0)} m²</span>
                <span className="text-blue-600">{(pond.max_depth_m * 100).toFixed(1)} cm</span>
              </div>
            ))}
          </CardContent>
        </Card>
      )}
    </div>
  );
}
